import { render, staticRenderFns } from "./SSelectLang.vue?vue&type=template&id=eb179166&scoped=true"
import script from "./sSelectLang.ts?vue&type=script&lang=ts&external"
export * from "./sSelectLang.ts?vue&type=script&lang=ts&external"
import style0 from "./SSelectLang.vue?vue&type=style&index=0&id=eb179166&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb179166",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb179166')) {
      api.createRecord('eb179166', component.options)
    } else {
      api.reload('eb179166', component.options)
    }
    module.hot.accept("./SSelectLang.vue?vue&type=template&id=eb179166&scoped=true", function () {
      api.rerender('eb179166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/s-select-lang/SSelectLang.vue"
export default component.exports